export default __webpack_public_path__ + "static/media/224.bc97a023.png";